import classnames from 'classnames';
import type { MouseEvent, ReactElement } from 'react';
import { plural } from '../../../../shared/helpers';
import { verify_subscription } from '../../../utils';
import Flex from '../../generic/Flex';
import Icon, { icons } from '../../generic/Icon';
import AlertLimitedScanDepth from '../AlertLimitedScanDepth';
import ButtonRescanProject from '../ButtonRescanProject';
import type { ProjectDashboardProject, ProjectDashboardRevision, RevisionRouteParams } from '../projectDashboardTypes';
import type { ScanStatus } from './ProjectSummaryIssues';
import ProjectSummaryIssueScanDropdown from './ProjectSummaryIssueScanDropdown';

type OwnProps = {
  params: RevisionRouteParams;
  project: ProjectDashboardProject;
  revision: ProjectDashboardRevision;
  issueCount: number;
  status: ScanStatus;
  routerPush(path: string): void;
  onScanIssues(ev: MouseEvent<HTMLElement>): void;
};

// this is the issues scan status that shows up on the header's left side
const ScanStatusLabel = ({ status, issueCount }: { status: ScanStatus; issueCount: number }): ReactElement => {
  if (status === 'SUCCEEDED') {
    return (
      <>
        <Icon icon={icons.check} /> All Checks Passed
      </>
    );
  }
  if (status === 'FAILED') {
    return (
      <>
        {issueCount} {plural(issueCount, 'Issue')}
      </>
    );
  }
  return <>Not Scanned Yet</>;
};

const ProjectSummaryIssuesSummaryHeader = ({
  params,
  project,
  revision,
  issueCount,
  status,
  routerPush,
  onScanIssues,
}: OwnProps) => {
  const issuesSummaryStatusClassname = classnames('project-summary-header', {
    'project-summary-success': status === 'SUCCEEDED',
    'project-summary-failed': status === 'FAILED',
  });

  return (
    <div className={issuesSummaryStatusClassname}>
      <Flex align="center" justify="space-between">
        <div className="project-summary-header__scan-dropdown">
          <ProjectSummaryIssueScanDropdown
            params={params}
            revision={revision}
            routerPush={routerPush}
          />
          <h4>
            <ScanStatusLabel status={status} issueCount={issueCount} />
            {status !== 'PENDING' &&
              <ButtonRescanProject
                project={project}
                revision={revision}
                onScanIssues={onScanIssues}
              />}
          </h4>
        </div>
        <div className="project-summary-header__vendored-action-buttons text-right">
          {!verify_subscription('premium') && <AlertLimitedScanDepth />}
        </div>
      </Flex>
    </div>);
};

export default ProjectSummaryIssuesSummaryHeader;
